/* CreativeWall ジクレー印刷 商品ページ（sections/cw-giclee-product.liquid） */
(function () {
  var root = document.querySelector('.cwg-product');
  var dataEl = document.querySelector('[data-cwg-product]');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };

  // ---- 金額表示（ショップの通貨フォーマットに合わせる） ----
  function money(cents) {
    var n = Math.round(cents / 100).toLocaleString('ja-JP');
    return D.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, n);
  }

  // ---- サイズ名と寸法：「F0号(180×140)」→ ["F0号", 180, 140] ----
  function parseSize(v) {
    var m = String(v).match(/^(.*?)\s*[(（]\s*(\d+)\s*[×xX]\s*(\d+)/);
    return m ? [m[1], +m[2], +m[3]] : [v, 0, 0];
  }

  function selected(i) {
    var el = root.querySelector('input[data-opt="' + i + '"]:checked');
    return el ? el.value : null;
  }
  function currentOptions() {
    var o = [];
    for (var i = 0; i < 3; i++) { var v = selected(i); if (v !== null) o.push(v); }
    return o;
  }
  function findVariant(opts) {
    return D.variants.find(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); });
  }
  function priceOf(opts) { var v = findVariant(opts); return v ? v.price : null; }

  // ---- お部屋プレビュー ----
  var room = 0;
  var picker = $('[data-room-picker]');
  if (picker) {
    picker.innerHTML = D.rooms.map(function (r, i) {
      return '<button type="button" aria-pressed="' + (i === 0) + '" aria-label="' + r.name + '"><img src="' + r.src + '" alt="" loading="lazy"></button>';
    }).join('');
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      room = [].indexOf.call(picker.children, b);
      [].forEach.call(picker.children, function (x, i) { x.setAttribute('aria-pressed', i === room); });
      $('[data-room-img]').src = D.rooms[room].src;
      update();
    });
  }
  function placeArt(w, h) {
    var art = $('[data-art]'); if (!art || !w) return;
    var r = D.rooms[room], W = w * r.s / 1080 * 100, H = h * r.s / 800 * 100;
    art.style.width = W + '%'; art.style.height = H + '%';
    art.style.left = (r.cx / 10.8 - W / 2) + '%'; art.style.top = (r.cy / 8 - H / 2) + '%';
  }
  var REFS = [['ハガキ', 148], ['A4', 297], ['A3', 420], ['A2', 594], ['A1', 841], ['B1', 1030]];
  function compare(w, h) {
    var L = Math.max(w, h), r = REFS[0];
    REFS.forEach(function (x) { if (x[1] <= L * 1.05) r = x; });
    var k = L / r[1];
    return '長辺' + (L / 10) + 'cm：' + r[0] + (k < 1.05 ? 'とほぼ同じ' : k < 1.25 ? 'より少し大きい' : 'よりひと回り大きい');
  }

  // ---- 選択状態の反映 ----
  var dpiPx = null, fileNote = '', noteCls = 'cwg-ok';
  function update() {
    var opts = currentOptions();
    var v = findVariant(opts);
    var sz = parseSize(opts[0]), w = sz[1], h = sz[2];
    var qty = Math.max(1, parseInt($('[data-qty]').value, 10) || 1);
    var price = v ? v.price : 0, tot = price * qty;

    if (v) $('[data-variant-id]').value = v.id;
    var add = $('[data-add]');
    if (add) { add.disabled = !(v && v.available); add.textContent = v && v.available ? 'カートに追加' : '売り切れ'; }

    $('[data-price]').textContent = money(price);
    var selText = [sz[0]].concat(opts.slice(1, 2)).join('・') + (opts[2] && opts[2] !== firstValue(2) ? '・画質向上' : '');
    $('[data-price-sel]').textContent = selText;
    $('[data-size-val]').textContent = w ? sz[0] + ' ' + w + '×' + h + 'mm' : sz[0];

    // 用紙ごとの差額（同じサイズ・画質向上なしで比較）
    $$('[data-delta]').forEach(function (el) {
      var base = priceOf([opts[0], firstValue(1)].concat(opts.length > 2 ? [firstValue(2)] : []));
      var p = priceOf([opts[0], el.getAttribute('data-delta')].concat(opts.length > 2 ? [firstValue(2)] : []));
      var d = (p !== null && base !== null) ? p - base : 0;
      el.textContent = d ? '+' + money(d) : '基本';
    });
    $$('[data-delta3]').forEach(function (el) {
      var base = priceOf([opts[0], opts[1], firstValue(2)]);
      var p = priceOf([opts[0], opts[1], el.getAttribute('data-delta3')]);
      var d = (p !== null && base !== null) ? p - base : 0;
      el.textContent = d ? '+' + money(d) : '';
    });

    setText('[data-s-size]', w ? sz[0] + '（' + w + '×' + h + 'mm）' : sz[0]);
    setText('[data-s-paper]', opts[1] || '');
    setText('[data-s-upg]', opts[2] || '');
    setText('[data-s-tot]', money(tot));
    setText('[data-ship-note]', tot >= 1000000 ? '送料無料でお届けします' : 'あと' + money(1000000 - tot) + 'で送料無料');
    setText('[data-st-sel]', selText + (qty > 1 ? ' ×' + qty : ''));
    setText('[data-st-price]', money(tot));

    // 価格表のハイライト
    $$('[data-ptable] tbody tr').forEach(function (tr) {
      var on = tr.getAttribute('data-size') === opts[0];
      tr.classList.toggle('cwg-cur', on);
      [].forEach.call(tr.querySelectorAll('td'), function (td) { td.classList.toggle('cwg-cur', on && td.getAttribute('data-paper') === opts[1]); });
    });

    placeArt(w, h);
    setText('[data-room-size]', w ? sz[0] + '（' + w + '×' + h + 'mm）' : sz[0]);
    setText('[data-cmp]', w ? compare(w, h) : '');
    checkDpi();
  }
  function setText(s, t) { var el = $(s); if (el) el.textContent = t; }
  function firstValue(i) { var el = root.querySelector('input[data-opt="' + i + '"]'); return el ? el.value : null; }

  root.addEventListener('change', function (e) { if (e.target.matches('[data-opt]')) update(); });
  $$('[data-q]').forEach(function (b) {
    b.addEventListener('click', function () { var q = $('[data-qty]'); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (+b.getAttribute('data-q'))); update(); });
  });
  $('[data-qty]').addEventListener('input', update);

  // ---- 入稿データの解像度チェック（入稿アプリのファイル選択に連動・jpeg/pngのみ） ----
  function checkDpi() {
    var el = $('[data-check]'); if (!el) return;
    if (!dpiPx) { el.className = fileNote ? 'cwg-check ' + noteCls : 'cwg-check'; el.textContent = fileNote; return; }
    var opts = currentOptions(), sz = parseSize(opts[0]);
    var side = D.panel ? 40 : 0, W = sz[1] + side, H = sz[2] + side;
    if (!W) return;
    var pw = (dpiPx.w >= dpiPx.h) === (W >= H) ? dpiPx.w : dpiPx.h;
    var ph = pw === dpiPx.w ? dpiPx.h : dpiPx.w;
    var dpi = Math.round(Math.min(pw / (W / 25.4), ph / (H / 25.4)));
    var upgOn = opts[2] && opts[2] !== firstValue(2);
    if (dpi >= 300) {
      el.className = 'cwg-check cwg-ok';
      el.textContent = '✓ ' + dpiPx.w + '×' + dpiPx.h + 'px：' + sz[0] + 'で約' + dpi + 'dpi。きれいに印刷できます。';
    } else {
      el.className = 'cwg-check cwg-warn';
      el.innerHTML = dpiPx.w + '×' + dpiPx.h + 'px：' + sz[0] + 'では約' + dpi + 'dpi（推奨300dpi）。仕上がりが粗くなる可能性があります。' +
        (upgOn ? '<br>画質向上オプションを選択済みです。' : (root.querySelector('input[data-opt="2"]') ? '<br><button type="button" data-use-upg>画質向上を追加する</button>' : ''));
      var b = el.querySelector('[data-use-upg]');
      if (b) b.addEventListener('click', function () { var r = root.querySelectorAll('input[data-opt="2"]'); r[r.length - 1].checked = true; update(); });
    }
  }
  function readFile(f) {
    if (!f) return;
    var face = $('[data-art-face]');
    if (!/image\/(jpeg|png)/.test(f.type)) {
      dpiPx = null; noteCls = 'cwg-ok'; fileNote = '✓ 添付しました。psd・aiは当社で確認後、メールでご連絡します。';
      if (face) { face.style.backgroundImage = ''; face.classList.remove('cwg-user'); }
      checkDpi(); return;
    }
    fileNote = '';
    var img = new Image();
    img.onload = function () {
      dpiPx = { w: img.naturalWidth, h: img.naturalHeight };
      if (face) { face.style.backgroundImage = 'url("' + img.src + '")'; face.classList.add('cwg-user'); }
      checkDpi();
    };
    img.src = URL.createObjectURL(f);
  }
  // ---- 入稿データ：選んだファイルはカート追加時に注文の明細（入稿データ）として添付される ----
  // Shopifyのファイル添付は1ファイル20MB未満（20MB以上はカート追加時にエラーになる）
  var MAX_BYTES = 20 * 1048576;
  var up = $('[data-upload]'), drop = $('[data-drop]'), fileIn = $('[data-file]'), fileName = $('[data-file-name]');
  var dropB0 = drop ? drop.querySelector('b').textContent : '', dropS0 = drop ? drop.querySelector('span').textContent : '';
  function sizeText(n) { return n < 1048576 ? Math.max(1, Math.round(n / 1024)) + 'KB' : (n / 1048576).toFixed(1) + 'MB'; }
  function pickFile(f) {
    if (!f) return;
    if (f.size >= MAX_BYTES) {
      if (fileIn) fileIn.value = '';
      if (fileName) { fileName.value = ''; fileName.disabled = true; }
      if (drop) { drop.querySelector('b').textContent = dropB0; drop.querySelector('span').textContent = dropS0; }
      setText('[data-s-file]', '未添付');
      var face = $('[data-art-face]');
      if (face) { face.style.backgroundImage = ''; face.classList.remove('cwg-user'); }
      dpiPx = null; noteCls = 'cwg-warn';
      fileNote = f.name + '（' + sizeText(f.size) + '）は20MB以上のため添付できません。20MB未満のデータを選ぶか、ご注文後にメール（cw.contact@nichidai-gravure.biz）でお送りください。';
      checkDpi(); return;
    }
    if (drop) {
      drop.querySelector('b').textContent = f.name;
      drop.querySelector('span').textContent = sizeText(f.size) + ' ／ クリックで変更';
    }
    if (fileName) { fileName.value = f.name; fileName.disabled = false; }
    setText('[data-s-file]', f.name);
    readFile(f);
  }
  if (up) up.addEventListener('change', function (e) { if (e.target.type === 'file' && e.target.files) pickFile(e.target.files[0]); }, true);
  if (drop && fileIn) {
    ['dragover', 'dragenter'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('cwg-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('cwg-over'); }); });
    drop.addEventListener('drop', function (e) {
      var fs = e.dataTransfer && e.dataTransfer.files;
      if (!fs || !fs.length) return;
      try { fileIn.files = fs; } catch (err) {}
      pickFile(fs[0]);
    });
  }

  // ---- 固定購入バー（スマホ）：購入ボックスが見えていない間だけ表示 ----
  var st = $('[data-sticky]'), buy = $('[data-buy]'), stAdd = $('[data-st-add]');
  function stick() {
    var r = buy.getBoundingClientRect();
    var show = window.scrollY > 300 && (r.bottom < 0 || r.top > innerHeight);
    st.classList.toggle('cwg-show', show); st.setAttribute('aria-hidden', !show); stAdd.tabIndex = show ? 0 : -1;
  }
  addEventListener('scroll', function () { requestAnimationFrame(stick); }, { passive: true });
  addEventListener('resize', stick);

  // ---- サイズ感プレビューの置き場所：高さに余裕のあるPCは左カラム、それ以外はサイズ選択の直下 ----
  var mq = matchMedia('(min-width:1024px) and (min-height:820px)');
  function placeRoom() { var r = $('[data-room]'); if (r) (mq.matches ? $('[data-slot-desk]') : $('[data-slot-mobile]')).appendChild(r); }
  if (mq.addEventListener) mq.addEventListener('change', placeRoom); placeRoom();

  // ---- ギャラリー ----
  var track = $('[data-track]'), dots = $('[data-dots]'), thumbs = $('[data-thumbs]');
  var figs = track ? [].slice.call(track.children) : [];
  figs.forEach(function (f, i) {
    function go() { track.scrollTo({ left: f.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', '画像' + (i + 1)); d.onclick = go; dots.appendChild(d);
    var t = document.createElement('button'); t.type = 'button'; t.setAttribute('aria-label', '画像' + (i + 1));
    var im = f.querySelector('img'); t.innerHTML = '<img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy">'; t.onclick = go; thumbs.appendChild(t);
  });
  function cur() {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    [].forEach.call(dots.children, function (b, j) { b.setAttribute('aria-current', j === i); });
    [].forEach.call(thumbs.children, function (b, j) { b.setAttribute('aria-current', j === i); });
  }
  if (track) { track.addEventListener('scroll', function () { requestAnimationFrame(cur); }, { passive: true }); cur(); }
  if (figs.length < 2) { dots.hidden = true; thumbs.hidden = true; }

  update();
})();
